<template lang="pug">
  button.hamburgerButton(:class="{showclose: close}")
    span
      .top-line.line
      .center-line.line
      .bottom-line.line
</template>

<script>
import debug from 'debug'
// import { mapActions, mapState } from 'vuex'

let log = debug('component:HamburgerButton')

export default {
  name: 'hamburgerButton',
  props: {
    close: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
    }
  },
  mounted () {
    log('Mounted')
  },
  computed: {
    // ...mapState('tasks', ['allTasks'])
  },
  methods: {
    // ...mapActions('tasks', ['syncTask'])
  },
  components: {
  },
}
</script>

<style scoped lang="scss">
$transitonTime: 200ms;

.hamburgerButton {
  height: 20px;
  padding: 4px;
  border: 0;
  background: transparent;
  outline: none !important;

  span {
    left: 0;
    top: 0;
    height: 2px;
    width: 16px;
    position: relative;
    display: block;

    .line {
      position: absolute;
      height: 100%;
      width: 100%;

      &::after {
        content: '';
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        border-radius: 2px;
        background: $siteLight;
        transform: translate(0, 0) rotate(0deg);
        transition: width $transitonTime $transitonTime linear, transform $transitonTime 0ms linear;
      }
    }

    .center-line {
      &::after {
        left: 0;
      }
    }

    .top-line {
      top: -5px;

      &::after {
        right: 0;
      }
    }

    .bottom-line {
      top: 5px;

      &::after {
        left: 0;
        width: 51%;
      }
    }
  }

  &.showclose {
    span {
      .line {
        &::after {
          transition: width $transitonTime 0ms linear, transform $transitonTime $transitonTime linear;
        }
      }

      .center-line {
        &::after {
          transform: translate(0, 0) rotate(45deg);
        }
      }

      .top-line {
        &::after {
          width: 51%;
          transform: translate(-1px, 2px) rotate(-45deg);
        }
      }

      .bottom-line {
        &::after {
          transform: translate(1px, -2px) rotate(-45deg);
        }
      }
    }
  }
}
</style>
